/**
 * All the Dealers Microsites's page names.
 */
export const PAGE_NAMES = {
  PAGE_NOT_FOUND: 'page_not_found',
  getDealerCenterPageName: pageCategory => `dealercenter${pageCategory ? `_${pageCategory}` : ''}`,
};
